import angular = require("angular");
import TPL = require("templates");

export class InputComboDirective {

  template = TPL.commonDirectives.inputCombo;
  scope = {
    params: "=params",
    parentform: "=parentform",
    value: "=value"
  };

  link;

  constructor() {
    this.link = (scope, el, attrs) => {
        scope.vm = {

      }
    }
  }


  static factory() {
    var tmp = () => new InputComboDirective();
    return tmp;
  }
}



/** WEBPACK FOOTER **
 ** ./src/scripts/directives/common/inputCombo.ts
 **/